/* =========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/   o o o  

========================================================= */

import React, { useEffect } from "react";
import { clearState } from "redux/actions/appAction";
import { useDispatch } from "react-redux";

// @mui material components
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

function Logout() {
  const loading = true;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearState());
    window.location.replace("/signin");
  }, []);

  return (
    <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Logout;
